var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaution(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    width: 72,
    height: 64,
    viewBox: "0, 0, 72, 64",
    transform: "scale(0.5)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36,0 C38.501,0 40.653,1.423 41.844,3.438 L70.094,51.25 C70.104,51.25 70.115,51.25 70.125,51.25 C71.044,52.84 72,54.79 72,57.125 C72,60.891 68.921,64 65.156,64 L6.844,64 C3.079,64 0,60.891 0,57.125 C0,54.79 0.956,52.84 1.875,51.25 C1.885,51.25 1.896,51.25 1.906,51.25 L30.156,3.438 C31.347,1.423 33.499,0 36,0 z M36,4 C34.789,4 34.277,4.344 33.594,5.5 L5.344,53.25 C5.339,53.258 5.349,53.271 5.344,53.281 C4.551,54.657 4,55.949 4,57.125 C4,58.733 5.244,60 6.844,60 L65.156,60 C66.756,60 68,58.733 68,57.125 C68,55.949 67.449,54.657 66.656,53.281 C66.651,53.273 66.661,53.26 66.656,53.25 L38.406,5.5 C37.723,4.344 37.211,4 36,4 z",
    fill: "#FFDE18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.781,19.969 C36.354,19.906 36.926,20.093 37.351,20.482 C37.776,20.871 38.012,21.424 38,22 L38,42 C38.01,42.721 37.631,43.392 37.008,43.756 C36.385,44.119 35.615,44.119 34.992,43.756 C34.369,43.392 33.99,42.721 34,42 L34,22 C33.978,20.964 34.751,20.082 35.781,19.969 z",
    fill: "#C40000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,47 C37.657,47 39,48.343 39,50 C39,51.657 37.657,53 36,53 C34.343,53 33,51.657 33,50 C33,48.343 34.343,47 36,47 z",
    fill: "#C40000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/caution.2bb4e10f.svg";
export { ForwardRef as ReactComponent };